import React, { useState, useRef } from 'react'
import '../Style/ServerManager.css'
import CloseIcon from '../Logos/x.svg'
import ThumbnailIcon from '../Logos/image.svg'
import DescriptionIcon from '../Logos/comment-chat-message2.svg'
import PencilIcon from '../Logos/edit.svg'
import PenIcon from '../Logos/pen-tool.svg'
import TagIcon from '../Logos/hashtag-trending-number.svg'
import AddIcon from '../Logos/plus.svg'
import CloseRedIcon from '../Logos/x-close-delete.svg'
import ParagraphIcon from '../Logos/text-paragraph.svg'
import ArrowDownIcon from '../Logos/chevron-down-arrow.svg'


function ServerManagerCom(props, { Section, Type }) {
  const [BlogsTag, SetBlogsTag] = useState([])
  const [AddingTag, SetAddingTag] = useState(false)
  const [BlogTitle, SetBlogTitle] = useState()
  const [BlogWriter, SetBlogWriter] = useState()
  const [BlogMainDescription, SetBlogMainDescription] = useState()
  const [BlogThumbnailToMySQL, SetBlogThumbnail] = useState()
  
  const BlogThumbnail = useRef()

  const Handle_Pic_Change = (e) => {
    const ImageURL = URL.createObjectURL(e.target.files[0])
    BlogThumbnail.current.style.backgroundImage = `url('${ImageURL}')`;
  }


  const Handle_Add_Blog = (e) => {
    e.preventDefault()
  }
  return (
    <>
      <div className='Manager-container'>
        <div className='close-manager' onClick={() => {props.OnFomClose()}}>
          <img src={CloseIcon} />
        </div>
        <form className='add-blog-container' onSubmit={(e) => {Handle_Add_Blog(e)}}>
          <div className='manager-title'>افزودن بلاگ</div>
          <div className='blog-title-input'>
            <img src={PencilIcon} />
            <input name='blog_title' type='text' placeholder='موضوع...' onChange={(e) => {SetBlogTitle(e.target.value)}}/>
          </div>
          <div className='blog-writer-container'>
            <img src={PenIcon} />
            <input name='blog_writer' placeholder='نویسنده...' onChange={(e) => {SetBlogWriter(e.target.value)}}/>
          </div>
          <div className='blog-tags-input'>
            <div className='title'>
              <div className='text'>تگ ها</div>
              <img src={TagIcon} />
            </div>
            <div className='tags-container'>
              <div className='add-tag'>
                {AddingTag ? <div className='remove-tag-button'>
                  <img src={CloseRedIcon} />
                </div> : <div className='add-tag-button'>
                  <img src={AddIcon} />
                </div>}
                <input type='text' placeholder='تگ...' className={AddingTag ? "tag-input-active" : "tag-input-disabled"} />
              </div>
              <div className='tag'>
                <div className='delete'>
                  <img src={CloseIcon} />
                </div>
                <div className='tag-name'>لامپ</div>
                <img src={TagIcon} />
              </div>
            </div>
          </div>
          <div className='sections-contianer'>
            <div className='title'>
              <div className='text'>بخش ها</div>
              <img src={ParagraphIcon} />
            </div>
            <div className='sections-list'>
              <div className='section'>
                <div className='section-title'>
                  <img src={ArrowDownIcon} />
                  <div className='title'>بخش 1</div>
                </div>
                <div className='setting'>
                  <div className='section-title-input'>
                    <img src={PencilIcon} />
                    <input type='text' name='section_title_input' placeholder='موضوع...' />
                  </div>
                  <div className='section-description-input'>
                    <img src={ParagraphIcon} />
                    <textarea name='section_description_input' placeholder='توضیحات...' />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='blog-main-description'>
            <img src={DescriptionIcon} />
            <textarea name='blog_main_description' type='text' placeholder='توضیحات اصلی...' onChange={(e) => {SetBlogMainDescription(e.target.value)}}/>
          </div>
          <div className='blog-thumbnail'>
            <input type='file' name='blog_thumbnail' onChange={(e) => {Handle_Pic_Change(e)}}/>
            <img src={ThumbnailIcon} />
            <div className='text'>عکس خود را بکشید روی اینجا یا بر روی اینجا کلیک کنید</div>
            <div className='BlogThumbnail' ref={BlogThumbnail}></div>
          </div>
          <button className='submit-blog' type='submit'>ثبت بلاگ</button>
        </form>
      </div>
    </>
  )
}

export default ServerManagerCom